class HighlightMarkdownCode {
  static ready () {
    const codeBlocks = [...document.querySelectorAll('.md pre code[class]')];
    if (codeBlocks.length === 0) return;

    import('prismjs').then(async (prismModule) => {
      const Prism = prismModule.default || prismModule;
      globalThis.Prism = Prism;

      await import('prismjs/components/prism-ruby');

      codeBlocks.forEach(($code) => {
        const lang = $code.getAttribute('class');
        if (!lang || !Prism.languages[lang]) return;

        $code.innerHTML = Prism.highlight($code.innerHTML, Prism.languages[lang], lang);
      });
    });
  }
}

export default HighlightMarkdownCode;
